// Property Entrata Section - Entrata ledger settings
import React from 'react';
import { FormSection, NumericFormField } from '@/components/common/admin/form';

interface PropertyEntrataSectionProps {
  propertyCashAccountId: string;
  accountsReceivableToResioAccountId: string;
  convenienceFeeAccountId: string;
  onPropertyCashAccountIdChange: (value: string) => void;
  onAccountsReceivableChange: (value: string) => void;
  onConvenienceFeeChange: (value: string) => void;
  disabled?: boolean;
}

export const PropertyEntrataSection: React.FC<PropertyEntrataSectionProps> = ({
  propertyCashAccountId,
  accountsReceivableToResioAccountId,
  convenienceFeeAccountId,
  onPropertyCashAccountIdChange,
  onAccountsReceivableChange,
  onConvenienceFeeChange,
  disabled,
}) => {
  return (
    <FormSection title="Entrata Ledger Settings">
      <NumericFormField
        label="Property Cash Account ID"
        value={propertyCashAccountId}
        onChangeText={onPropertyCashAccountIdChange}
        placeholder="Optional"
        editable={!disabled}
      />

      <NumericFormField
        label="Accounts Payable to Resio Account ID"
        value={accountsReceivableToResioAccountId}
        onChangeText={onAccountsReceivableChange}
        placeholder="Optional"
        editable={!disabled}
      />

      <NumericFormField
        label="Convenience Fee Account ID"
        value={convenienceFeeAccountId}
        onChangeText={onConvenienceFeeChange}
        placeholder="Optional"
        editable={!disabled}
      />
    </FormSection>
  );
};

